import { getMetaValue } from './getMetaValue';

// NOTE: (TomLuce) Important we use a function as a const may well be stale
export const getCsrfToken = () => getMetaValue('csrf-token');
